import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectRol, selectUser } from "src/redux/slices/authSlice"
import { selectConjunto } from "src/redux/slices/complexSlice"
import { getNavSections, needsComplexModules } from "src/navigation"
import useComplexModules from "./useComplexModules"

const useNavSections = () => {
  const { t: tGlobal } = useTranslation("global")
  const rol = useSelector(selectRol)
  const user = useSelector(selectUser)
  const conjunto = useSelector(selectConjunto)
  const shouldLoadModules = needsComplexModules(rol)
  const modulos = useComplexModules(shouldLoadModules ? conjunto?.id : null)

  return useMemo(
    () => getNavSections(rol, { t: tGlobal, modulos, user }),
    [rol, tGlobal, modulos, user]
  )
}

export default useNavSections
